import { combineReducers } from 'redux'

import setting from './settings'

export const reducer = combineReducers({
  setting: setting.reducer,
})

export default reducer
